/*!
 * Copyright (c) 2015-2017 Cisco Systems, Inc. See LICENSE file.
 */

import {registerInternalPlugin} from '@ciscospark/spark-core';
import Device from './device';
import config from './config';

import UrlInterceptor from './interceptors/url';
import DeviceUrlInterceptor from './interceptors/device-url';
import EmbargoInterceptor from './interceptors/embargo';
import ServerErrorInterceptor from './interceptors/server-error';

registerInternalPlugin('device', Device, {
  interceptors: {
    UrlInterceptor: UrlInterceptor.create,
    DeviceUrlInterceptor: DeviceUrlInterceptor.create,
    EmbargoInterceptor: EmbargoInterceptor.create,
    ServerErrorInterceptor: ServerErrorInterceptor.create
  },
  config,
  onBeforeLogout() {
    return this.unregister();
  }
});

export {default} from './device';
export {default as Device} from './device';
export {default as FeaturesModel} from './device/features-model';
export {default as FeatureCollection} from './device/feature-collection';
export {default as FeatureModel} from './device/feature-model';
export {default as ServiceCollection} from './device/service-collection';
export {default as ServiceModel} from './device/service-model';
export {default as EmbargoInterceptor} from './interceptors/embargo';
export {default as UrlInterceptor} from './interceptors/url';
export {default as DeviceUrlInterceptor} from './interceptors/device-url';
export {default as ServerErrorInterceptor} from './interceptors/server-error';
export {default as config} from './config';
